import { Skeleton } from "@/components/ui/skeleton";
import React from "react";

const SkeletonSuggestion = () => {
  return (
    <div className="hidden xl:block lg:w-[25.8vw] bg-white space-y-7 py-10 pl:0 lg:pl-5 pr-9 text-sm">
      <div className="flex space-x-3 justify-between items-center">
        <div className="flex space-x-4 items-center">
          <Skeleton className={`w-[56px] h-[56px] rounded-full`} />
          <div className="flex flex-col space-y-1 overflow-hidden">
            <Skeleton className="rounded-lg h-3 w-28" />
            <Skeleton className="rounded-lg h-3 w-12" />
          </div>
        </div>
        <Skeleton className="rounded-lg h-3 w-10" />
      </div>
      <div className="space-y-5">
        <div className="flex justify-between">
          <Skeleton className="rounded-lg h-3 w-28" />
          <Skeleton className="rounded-lg h-3 w-10" />
        </div>
        {[0, 1, 2, 3, 4].map((item) => (
          <div
            className="flex space-x-3 justify-between items-center"
            key={item}
          >
            <div className="flex space-x-4 items-center">
              <Skeleton className={`w-[56px] h-[56px] rounded-full`} />
              <div className="flex flex-col space-y-1 overflow-hidden">
                <Skeleton className="rounded-lg h-3 w-24" />
                <Skeleton className="rounded-lg h-3 w-20" />
              </div>
            </div>
            <Skeleton className="rounded-lg h-3 w-10" />
          </div>
        ))}
      </div>
    </div>
  );
};

export default SkeletonSuggestion;
